import React from "react";
import { ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

export const AppFooter = ({ className = "" }) => (
  <footer className={`border-t border-border px-4 py-6 sm:px-6 ${className}`}>
    <div className="flex flex-col gap-3 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
      <p className="flex items-center gap-2">
        <ShieldCheck className="h-3.5 w-3.5 text-[hsl(var(--profit))]" />
        Secured by SSL · Invextiing Capital · invextiing.com
      </p>
      <p className="flex items-center gap-4">
        <Link to="/privacy" className="underline-offset-4 hover:underline" data-testid="footer-privacy-link">
          Privacy
        </Link>
        <Link to="/terms" className="underline-offset-4 hover:underline" data-testid="footer-terms-link">
          Terms
        </Link>
        <span>© {new Date().getFullYear()} Invextiing</span>
      </p>
    </div>
  </footer>
);
